import { EdgesPage } from '@elentari/core/types'
import { makeRepository } from '@elentari/core/utils/makeRepository'
import { ParsedQs } from 'qs'
import { apiSauceInstance } from '../../../services/api'
import { paginationParams } from '../../../utils/paginationQueryParams'
import { ModalidadeDetail, Modalidades } from '../types'

const mapQueryParams = (params: ParsedQs): ParsedQs => {
  const { limit, sort, ...rest } = params

  return {
    ...paginationParams(rest),
    limit: limit || '10',
    sort
  }
}

export const modalidadesRepository = makeRepository<
  EdgesPage<ModalidadeDetail>,
  Modalidades,
  ModalidadeDetail,
  string
>({ resource: 'modalidades', mapQueryParams }, apiSauceInstance)
